import { useModal } from '@shared/model/useModal';

export const useTeacherModal = () => useModal('teacher')